// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2E09G","title":"styles_title__Yi4Jw"};